export default __webpack_public_path__ + "static/tri-screen-lockup-579048c6de778116c156835baa208dc3.png";